<template>
  <section>
      <p style="color: #f69346; font-size: 24px; font-weight: bold">
         高风险数据上传
      </p>
      <el-row>
        <el-col :span="2"><el-button @click="download" type="primary"> 下 载 模 板</el-button></el-col>
        <el-col :span="2"><el-button @click="download_data" type="primary"> 下 载 数 据 </el-button></el-col>
        <el-col :span="2">
          <el-upload
            class="upload-demo"
            ref="upload"
            action="/api/ws_highrisk/ImportExcel"
            :show-file-list="false"
            :headers="token"
            :data='{
              data:1
            }'
            :on-success='handleSuccess'
            :before-upload='handlebefore'
            :on-error='handonerror'
            :file-list="fileList">
          <el-button type="primary">导入数据</el-button>
          <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>   -->
        </el-upload>

        </el-col>
      </el-row>
       <h4>下载数据：下载所有高风险客户至excel表格</h4>
       <h4>下载模板：下载导入模板，按照对应表头维护相应数据</h4>
       <h4>导入数据：在模板中维护数据完成后，即可导入</h4>
       <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如匹配到当前数据已存在，则按照导入数据进行更新</h4>
       <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如匹配当前数据不存在，则新建，其他本次未导入数据保持不变</h4>
       <h4>数据模板：客户编号，客户名称，客户分组，是否高风险客户</h4>
  </section>
</template>

<script>
import util from "../../../util/date";
import { ws_highrisk_ExportData,ws_highrisk_GetImportTemplate } from "../../api/api";
import { getButtonList } from "../../promissionRouter";

export default {
  components: {},
  data() {
    return {
      token:{},
    };
  },
  methods: {
    handlebefore(){
      const loading = this.$loading({
            lock: true,
            text:'loading......'
          });
    },
    handonerror(){
      console.log('超时失败')
     
        const loading = this.$loading({
            lock: true,
            text:'loading......'
          });
           this.$message({
          message: "您的上传已超时，请再次尝试",
          type: "error",
        });
          loading.close();
    },
    handleSuccess(file, fileLis){
      const loading = this.$loading({
            lock: true,
            text:'loading......'
          });
      if(file.success  == true){
        loading.close();
        this.$message({
          message: file.msg,
          type: "error",
        });
        // this.$refs.upload.clearFiles(); 
      }else if(file.success == false){
        loading.close();
        this.$message({
          message: file.msg,
          type: "error",
        });
      }else{
        loading.close();
        this.$message({
          message: "您的上传已超时，请再次尝试",
          type: "error",
        });
      }
      this.$refs.upload.clearFiles(); 
    },
    download() {
        window.open("/api/ws_highrisk/GetImportTemplate")
      // var loading = this.$loading({
      //   lock: true,
      //   text: "loading......",
      // });
      // ws_highrisk_GetImportTemplate().then((res) => {
      //   console.log(res);
      //   if (res.data.status == 200) {
      //     loading.close();
      //     //window.open("http://47.103.87.196:8082" + res.data.msg);
      //     window.location.href = res.data.msg;
      //   } else {
      //     loading.close();
      //     this.$message({
      //       message: res.data.msg,
      //       type: "error",
      //     });
      //     // this.dialogVisible_msg = true
      //     // this.dialogVisible_msg_text =res.data.msg
      //   }
      // });
    },
    download_data() {
     
       window.open("/api/ws_highrisk/ExportData")
      // var loading = this.$loading({
      //   lock: true,
      //   text: "loading......",
      // });
      // ws_highrisk_ExportData().then((res) => {
      //   console.log(res);
      //   if (res.data.status == 200) {
      //     loading.close();
      //     //window.open("http://47.103.87.196:8082" + res.data.msg);
      //     window.location.href = res.data.msg;
      //   } else {
      //     loading.close();
      //     this.$message({
      //       message: res.data.msg,
      //       type: "error",
      //     });
      //     // this.dialogVisible_msg = true
      //     // this.dialogVisible_msg_text =res.data.msg
      //   }
      // });
    },
  },
  mounted() {
    // this.getModules();
    let roleNames = JSON.parse(localStorage.getItem("roleNames"));
    console.log(roleNames);
        
     let tokenStr = window.localStorage.Token; 
    this.token = {
      Authorization: "Bearer " + tokenStr,
    };
    // this.token = {
    //   Authorization: "Bearer " + tokenStr,
    // };

    // if(roleNames.find((e)=> {
    //     return e == 'AM' ;
    //   })){
    //       this.edit_if = false
    // }
  },
};
</script>

<style scoped>
</style>
